import { Injectable } from '@angular/core';
import { FNExceptionJson } from './fn-exception-json';

/**
 * service to send exception to server or to print in browser console.
 */
@Injectable()
export class FNErrorLogSvcs {
  /**
   * member variable of boolean type 
   * if true then send exception to Server.
   */
  public sendExceptionToServer: boolean;

  /**
   * Method to log the given error to various aggregation and tracking services.
   * @param error Object to print error message and error stack 
   */
  public logError(error: any): void {
    if (this.sendExceptionToServer) {
      const fnExpJson: FNExceptionJson = new FNExceptionJson(error);
      this.sendToServer(fnExpJson);
    } else {
      this.sendToConsole(error);
    }

  }

  /**
   * function to send the error to the browser console (safely, if it exists).
   * @param error Object to print error message and error stack
   */
  public sendToConsole(error: any): void {

    if (console && console.group && console.error) {

      console.group('Error Log Service');
      console.error(error);
      console.error(error.message);
      console.error(error.stack);
      console.groupEnd();

    }

  }


  /**
   * send the error to the server-side error tracking end-point
   * @param fnExpJson FNExceptionJson Object 
   */
  public sendToServer(fnExpJson: FNExceptionJson): void {

    // this.http
    // 	.post(
    // 		"./error-logging-endpoint", // Doesn't really exist in demo.
    // 		{
    // 			type: error.name,
    // 			message: error.message,
    // 			stack: error.stack,
    // 			location: window.location.href
    // 		}
    // 	)
    // 	.subscribe(
    // 		( httpResponse: Response ) : void => {

    // 			// ... nothing to do here.
    // 		},
    // 		( httpError: any ) : void => {

    // 			// NOTE: We know this will fail in the demo since there is no
    // 			// ability to accept POST requests on GitHub pages.
    // 			// --
    // 			// console.log( "Http error:", httpError );
    // 		}
    // 	)


  }

}
